import {
  PAYMENT_TYPE_CONFIG,
  PAYMENT_TYPE_FIELD_CONFIG,
  PAYMENT_TYPES,
} from "../config/lipaBidhaaConfig";
import CustomLoader from "../../ui/CustomLoader/CustomLoader";
import CustomButton from "../../ui/CustomButton/CustomButton";
import { SuccessView } from "./result/SuccessView";
import { FailedView } from "./result/FailedView";
import { ProcessingView } from "./result/ProcessingView";

export function Step4Result({
  paymentType,
  transactionUuid,
  transactionData,
  isLoadingTransaction,
  isTransactionError,
  refetchTransaction,
  businessName,
  accountNumber,
  verifiedAlias,
  walletBalance,
  remarks,
  draftTransactionAmount,
  draftTransactionFee,
  onNewPayment,
  onViewTransactions,
}) {
  const aliasLabel =
    PAYMENT_TYPE_FIELD_CONFIG[paymentType]?.aliasLabel ?? "Reference";
  const paybillAccountNumber =
    paymentType === PAYMENT_TYPES.PAYBILL ? accountNumber : null;

  if (!transactionUuid) {
    return (
      <FailedView
        businessName={businessName}
        accountNumber={paybillAccountNumber}
        transactionAmount={draftTransactionAmount}
        transactionFee={draftTransactionFee}
        transactionReference={null}
        verifiedAlias={verifiedAlias}
        aliasLabel={aliasLabel}
        remarks={remarks}
        createdDate={null}
        newBalance={null}
        walletBalance={walletBalance}
        onNewPayment={onNewPayment}
      />
    );
  }

  if (isLoadingTransaction) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <CustomLoader
          type="oval"
          color="primary"
          size="md"
          text="Fetching transaction details..."
          textPosition="center"
          textColor="text-primary-500"
        />
      </div>
    );
  }

  if (isTransactionError || !transactionData) {
    return (
      <div className="flex flex-col items-center gap-4 py-8">
        <p className="text-sm text-gray-600 text-center">
          Unable to load transaction details.
        </p>
        <CustomButton color="primary" radius="md" onClick={refetchTransaction}>
          Retry
        </CustomButton>
      </div>
    );
  }

  const {
    transactionId,
    createdDate,
    transactionFee,
    totalDeducted,
    newBalance,
    status,
    amount,
    mpesaReference,
    remarks: transactionRemarks,
  } = transactionData;

  const summaryRowsProps = {
    transactionReference: transactionId,
    createdDate,
    verifiedAlias,
    aliasLabel,
    accountNumber: paybillAccountNumber,
    transactionAmount: amount,
    transactionFee,
    total: totalDeducted,
    newBalance,
  };

  if (status === "SUCCESS") {
    return (
      <SuccessView
        {...summaryRowsProps}
        businessName={businessName}
        transactionAmount={amount}
        transactionType={PAYMENT_TYPE_CONFIG[paymentType]?.label}
        status={status}
        mpesaReference={mpesaReference}
        onNewPayment={onNewPayment}
        onViewTransactions={onViewTransactions}
      />
    );
  }

  if (status === "FAILED" || status === "REVERSED") {
    return (
      <FailedView
        {...summaryRowsProps}
        businessName={businessName}
        transactionAmount={amount}
        remarks={transactionRemarks}
        walletBalance={walletBalance}
        onNewPayment={onNewPayment}
      />
    );
  }

  return (
    <ProcessingView
      {...summaryRowsProps}
      onViewTransactions={onViewTransactions}
    />
  );
}
